/* Header Vehicle Quick-Nav — cascading 3-level selects with persistent collapsed state. */
(function () {
  'use strict';

  var STORAGE_KEY = 'cr-hvn-vehicle-v1';

  function init(root) {
    var dataEl = root.querySelector('[data-hvn-data]');
    if (!dataEl) return;

    var tree;
    try { tree = JSON.parse(dataEl.textContent); } catch (_) { return; }
    if (!Array.isArray(tree) || tree.length === 0) return;

    var l1 = root.querySelector('[data-hvn-level="1"]');
    var l2 = root.querySelector('[data-hvn-level="2"]');
    var l3 = root.querySelector('[data-hvn-level="3"]');
    var submit = root.querySelector('[data-hvn-submit]');
    var summary = root.querySelector('[data-hvn-summary]');
    var summaryText = root.querySelector('[data-hvn-summary-text]') || summary;
    var editBtn = root.querySelector('[data-hvn-edit]');
    if (!l1 || !l2 || !l3 || !submit || !summary || !editBtn) return;

    var placeholders = {
      1: l1.getAttribute('data-placeholder') || '–',
      2: l2.getAttribute('data-placeholder') || '–',
      3: l3.getAttribute('data-placeholder') || '–'
    };

    function makeOpt(label, value) {
      var o = document.createElement('option');
      o.textContent = label;
      if (value != null) o.value = value;
      return o;
    }

    function resetSelect(sel, placeholder, disabled) {
      sel.innerHTML = '';
      var p = makeOpt(placeholder, '');
      p.disabled = true;
      p.selected = true;
      sel.appendChild(p);
      sel.disabled = !!disabled;
    }

    function populate(sel, items, placeholder) {
      resetSelect(sel, placeholder, false);
      items.forEach(function (item, idx) {
        sel.appendChild(makeOpt(item.title, String(idx)));
      });
    }

    function selectedIdx(sel) {
      var opt = sel.options[sel.selectedIndex];
      return opt && opt.value !== '' ? +opt.value : -1;
    }

    function populateL2(brand) {
      var models = (brand && brand.children) || [];
      if (models.length > 0) {
        populate(l2, models, placeholders[2]);
      } else {
        resetSelect(l2, placeholders[2], true);
      }
    }

    function populateL3(model) {
      var typen = (model && model.children) || [];
      if (typen.length > 0) {
        populate(l3, typen, placeholders[3]);
      } else {
        resetSelect(l3, placeholders[3], true);
      }
    }

    function trimPrefix(child, parent) {
      if (!child || !parent) return child || '';
      var c = child.trim();
      var p = parent.trim();
      if (c.length > p.length && c.toLowerCase().indexOf(p.toLowerCase()) === 0) {
        var rest = c.slice(p.length).trim();
        if (rest) return rest;
      }
      return c;
    }

    function buildLabel(brand, model, typ) {
      var parts = [brand.title];
      if (model) {
        var modelLabel = trimPrefix(model.title, brand.title);
        parts.push(modelLabel);
        if (typ) {
          // Strip both brand and model prefixes from typ
          var typLabel = trimPrefix(typ.title, brand.title);
          typLabel = trimPrefix(typLabel, modelLabel);
          // Also try stripping the original model title in case of "Brand Model Typ"
          typLabel = trimPrefix(typLabel, model.title);
          parts.push(typLabel);
        }
      }
      return parts.join(' · ');
    }

    // A node is navigable only if it links to a real collection — frontpage
    // container items (e.g. "Weitere", "VW › Transporter") carry url "/".
    function isRealUrl(u) {
      return !!u && u !== '/';
    }

    // Returns the deepest *selected* node that links to a real collection, so the
    // customer can land on Marke, Marke+Modell, or Marke+Modell+Typ — whichever
    // level they stop at. null → nothing navigable selected (submit stays disabled).
    function currentSelection() {
      var i1 = selectedIdx(l1);
      var brand = i1 >= 0 ? tree[i1] : null;
      if (!brand) return null;

      var i2 = selectedIdx(l2);
      var model = i2 >= 0 && brand.children ? brand.children[i2] : null;

      // Marke allein → Marken-Kollektion
      if (!model) {
        if (!isRealUrl(brand.url)) return null;
        return { i1: i1, i2: -1, i3: -1, target: brand, label: buildLabel(brand, null, null) };
      }

      var i3 = selectedIdx(l3);
      var typ = i3 >= 0 && model.children ? model.children[i3] : null;

      // Marke + Modell + Typ → Typ-Kollektion
      if (typ) {
        if (!isRealUrl(typ.url)) return null;
        return { i1: i1, i2: i2, i3: i3, target: typ, label: buildLabel(brand, model, typ) };
      }

      // Marke + Modell (Typ offen, auch wenn Typen existieren) → Modell-Kollektion
      if (!isRealUrl(model.url)) return null;
      return { i1: i1, i2: i2, i3: -1, target: model, label: buildLabel(brand, model, null) };
    }

    function updateSubmit() {
      submit.disabled = !currentSelection();
    }

    function setCollapsed(label) {
      summaryText.textContent = label;
      summary.hidden = false;
      editBtn.hidden = false;
      root.setAttribute('data-hvn-collapsed', '');
    }

    function setExpanded() {
      summary.hidden = true;
      editBtn.hidden = true;
      root.removeAttribute('data-hvn-collapsed');
    }

    function saveSelection(sel) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          i1: sel.i1, i2: sel.i2, i3: sel.i3, label: sel.label, url: sel.target.url
        }));
      } catch (_) {}
    }

    function loadSelection() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (_) { return null; }
    }

    function clearSelection() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    }

    function commit() {
      var sel = currentSelection();
      if (!sel) return;
      saveSelection(sel);
      setCollapsed(sel.label);
      window.location.href = sel.target.url;
    }

    function reset() {
      clearSelection();
      populate(l1, tree, placeholders[1]);
      resetSelect(l2, placeholders[2], true);
      resetSelect(l3, placeholders[3], true);
      updateSubmit();
      setExpanded();
    }

    // Restore previous selection from localStorage (so dropdowns are pre-filled when user edits)
    function restoreFromStorage() {
      var saved = loadSelection();
      if (!saved || !saved.label) return false;
      var brand = tree[saved.i1];
      if (!brand) return false;

      populate(l1, tree, placeholders[1]);
      l1.value = String(saved.i1);
      populateL2(brand);

      // Marke-only selections store i2 === -1; deeper levels stay at placeholder.
      var model = (saved.i2 >= 0 && brand.children) ? brand.children[saved.i2] : null;
      if (model) {
        l2.value = String(saved.i2);
        if (model.children && model.children.length > 0 && saved.i3 >= 0) {
          populateL3(model);
          l3.value = String(saved.i3);
        } else {
          resetSelect(l3, placeholders[3], true);
        }
      } else {
        resetSelect(l3, placeholders[3], true);
      }
      updateSubmit();
      setCollapsed(saved.label);
      return true;
    }

    // Events
    l1.addEventListener('change', function () {
      var brand = tree[+l1.value];
      populateL2(brand);
      resetSelect(l3, placeholders[3], true);
      updateSubmit();
    });

    l2.addEventListener('change', function () {
      var brand = tree[+l1.value];
      var model = brand && l2.value !== '' ? brand.children[+l2.value] : null;
      // populateL3 handles the no-Typen case (resets + disables l3) internally.
      populateL3(model);
      updateSubmit();
    });

    l3.addEventListener('change', function () {
      updateSubmit();
    });

    submit.addEventListener('click', commit);
    root.addEventListener('submit', function (e) { e.preventDefault(); commit(); });

    editBtn.addEventListener('click', reset);
    summary.addEventListener('click', reset);

    // Init: collapsed if storage has a valid selection, else expanded with empty selects
    if (!restoreFromStorage()) {
      reset();
    }
  }

  function boot() {
    document.querySelectorAll('[data-hvn-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
